import { Component, OnInit, ViewContainerRef, inject } from '@angular/core';
import { AuthService } from './@core/Auth/auth.service';
import { ComponentFactory } from './@core/services/ComponentFactory/component-factory.service';
import { TokenService } from './@core/services/token.service';
import { OnlineStatusService, OnlineStatusType } from 'ngx-online-status';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'Laguna Bay Web Map';

  private readonly authService = inject(AuthService);
  private readonly componentFactory = inject(ComponentFactory);
  private readonly tokenService = inject(TokenService)
  private readonly onlineStatusService: OnlineStatusService = inject(OnlineStatusService);

  constructor(private viewContainerRef:ViewContainerRef) {


    this.onlineStatusService.status.subscribe((status: OnlineStatusType) => {

      if(status == OnlineStatusType.OFFLINE)
      return;

      this.authService.refreshToken().subscribe();
    });

    this.componentFactory.setTarget(viewContainerRef);

  }
  ngOnInit(): void {

  }


}
